import { SupplierRelationshipGetResponseType } from "@sellar-io/api-v2/types";
import { SpinnerLegacy } from "../../../../components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../../components/modal/Dialog";
import { useEvents } from "../../../../hooks";
import { usePriceTierList } from "../../../../hooks/api/v2/priceTier/usePriceTierList";
import { useSupplierRelationshipUpdate } from "../../../../hooks/api/v2/supplierRelationship/useSupplierRelationshipUpdate";
import { EditConnectionPropertiesFragment } from "./EditConnectionPropertiesFragment";

export const ConnectionAcceptModal = ({
  onDismiss,
  connection,
  active,
}: {
  onDismiss: () => void;
  connection: SupplierRelationshipGetResponseType | undefined;
  active: boolean;
}) => {
  const { track } = useEvents();
  const supplierRelationshipUpdateMutate = useSupplierRelationshipUpdate(
    parseInt(connection?.id.toString() ?? ""),
  );

  const priceTiersListQuery = usePriceTierList({});

  const priceTiers = (
    priceTiersListQuery.data?.pages.flatMap((pt) => pt) ?? []
  ).filter((pt) => pt.derivationType !== "base");

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Assign terms"}
        description={
          "Before accepting this connection request, you need to assign terms to this customer."
        }
      />
      <DialogContent>
        <>
          {!priceTiersListQuery.data?.pages[0]?.length ? (
            <div>
              You need to create a price tier before updating connections
            </div>
          ) : (
            <>
              {priceTiersListQuery.isLoading ||
              supplierRelationshipUpdateMutate.isPending ||
              !connection ? (
                <SpinnerLegacy />
              ) : (
                <EditConnectionPropertiesFragment
                  connection={connection}
                  buyerPostcode={
                    connection.Retailer.Business.DeliveryAddress.postalCode
                  }
                  priceTiers={priceTiers}
                  onSubmit={async (e) => {
                    await supplierRelationshipUpdateMutate.mutate(
                      {
                        PriceTierId: e.PriceTierId
                          ? parseInt(e.PriceTierId.toString())
                          : undefined,
                        AvailabilityTierId: e.AvailabilityTierId,
                        fulfillmentType: e.fulfillmentType,
                        paymentDue: e.paymentDue,
                        buyerContactEmail: e.buyerContactEmail,
                        retailerContactSmsNumber: e.retailerContactSmsNumber,
                        approved: true,
                        vatPercentage: e.vatPercentage,
                        paymentTerms: e.paymentTerms ?? null,
                        paymentDueCalculateFrom:
                          e.paymentDueCalculateFrom ?? null,
                        customerCode: e.customerCode,
                        notes: e.notes,
                      },
                      {
                        onSuccess: () => {
                          onDismiss();
                        },
                      },
                    );

                    await track("Connection Request Accepted");
                  }}
                />
              )}
            </>
          )}
        </>
      </DialogContent>
    </Dialog>
  );
};
